import React, { useRef, useEffect } from 'react'
import Alert from 'react-bootstrap/Alert'
import Image from 'react-bootstrap/Image'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
function Navbar2({ navItems, direction, language, currentElementIndexInViewport }) {

    const divRefN2 = useRef(null)

    useEffect(() => {
        const handleScroll = () => {
            if (divRefN2.current) {

                const { top } = divRefN2.current.getBoundingClientRect()
                // Check if the top of the div is at the top of the viewport
                if (top < 100) {
                    divRefN2.current.classList.add('topN2-45')
                } else {
                    divRefN2.current.classList.remove('topN2-45')
                }
            }
        }

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll)

        // Cleanup function
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    function next() {
        const activeNavItem = document.querySelector(".active-scroll-spy")
        var nextElement = activeNavItem.nextElementSibling
        if (nextElement) {
            activeNavItem.classList.remove('active-scroll-spy')
            nextElement.classList.add('active-scroll-spy')
            document.getElementById(nextElement.id).scrollIntoView({ inline: "center" })
            setTimeout(function () {
                let targetId = nextElement.id
                const activeItemId = targetId.replace('nav2', 'section')
                document.getElementById(activeItemId).scrollIntoView()
            }, 100)

        }
    }

    function prev() {
        const activeNavItem = document.querySelector(".active-scroll-spy")
        var prevElement = activeNavItem.previousElementSibling
        if (prevElement) {
            activeNavItem.classList.remove('active-scroll-spy')
            prevElement.classList.add('active-scroll-spy')
            prevElement.click()
            document.getElementById(prevElement.id).scrollIntoView({ inline: "center" })
            setTimeout(function () {
                let targetId = prevElement.id
                const activeItemId = targetId.replace('nav2', 'section')
                document.getElementById(activeItemId).scrollIntoView()
            }, 100)
        }
    }

    function handleSSItem(e) {
        let targetId = e.target.parentNode.id
        const activeItemId = targetId.replace('nav2', 'section')
        document.getElementById(activeItemId).scrollIntoView()
    }
    return (
        <>
            <Alert className='navbar2 d-flex justify-content-between align-items-center text-light text-uppercase ff-SomarSansExtraBold mx-1 sticky-top' data-cy="nav-wrapper" ref={divRefN2}>
                <div><Image src="../assets/prev.webp" className='nav-btn' onClick={direction === "ltr" ? prev : next} /></div>
                <Row className='h-scroll w-100 mx-1 h-nav2' dir={direction}>
                    {
                        navItems?.map((item, index) => {
                            return <Col key={"navbar2-" + index} id={"nav2-" + index} className={currentElementIndexInViewport === index ? "active-scroll-spy" : ""}><span onClick={handleSSItem} className="d-inline-block w-100 text-center">{language === "AR" ? item.ArabicName : item.Name}</span></Col>
                        })
                    }
                </Row>
                <div><Image src="../assets/next.webp" className='nav-btn' onClick={direction === "ltr" ? next : prev} /></div>
            </Alert>
            {/* <Row className='d-none'>
                <div className="d-flex justify-content-around text-light py-2 ff-SomarSansExtraBold">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" checked />
                        <label className="new-label" htmlFor="inlineCheckbox1"></label>
                        <label className="form-check-label ms-1 fs-3" htmlFor="inlineCheckbox1">FULL MENU</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2" />
                        <label className="new-label" htmlFor="inlineCheckbox2"></label>
                        <label className="form-check-label ms-1 fs-3" htmlFor="inlineCheckbox2">VEGETERIAN</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" id="inlineCheckbox3" value="option2" />
                        <label className="new-label" htmlFor="inlineCheckbox3"></label>
                        <label className="form-check-label ms-1 fs-3" htmlFor="inlineCheckbox3">VEGAN</label>
                    </div>
                </div>
            </Row> */}
        </>
    );
}

export default Navbar2;